module.exports = __webpack_public_path__ + "static/media/facebook.3116d5e7.svg";